<div class="pending-imports-container">
    <h5 class="modal-title">Processos de importação pendentes</h5>

    <div class="filters-container">
        <input
            type="text"
            placeholder="Busque um ou mais processos de importação"
            class="search-input search-input-dimension"
            (input)="search($event)"
        >
    </div>

    <div class="scope-tabs" *ngIf="!loading() && searchTerm() == ''">
        <button
            class="scope-tab"
            [class.active]="selectedScope() === PendingImportWizardScope.NOT_SHARED"
            (click)="handleScopeChange(PendingImportWizardScope.NOT_SHARED)"
        >
            Privados
            <span class="badge">{{ notSharedCount() }}</span>
        </button>
        <button
            class="scope-tab"
            [class.active]="selectedScope() === PendingImportWizardScope.SHARED"
            (click)="handleScopeChange(PendingImportWizardScope.SHARED)"
        >
            Compartilhados
            <span class="badge">{{ sharedCount() }}</span>
        </button>
        <button
            class="scope-tab"
            [class.active]="selectedScope() === PendingImportWizardScope.ALL"
            (click)="handleScopeChange(PendingImportWizardScope.ALL)"
        >
            Todos
            <span class="badge">{{ allCount() }}</span>
        </button>
    </div>

    <div class="pending-imports-list">
        @if(loading()) {
            <app-skeleton variant="horizontal-card" *ngFor="let i of [].constructor(3)"></app-skeleton>
        } @else if(!loading() && pendingImportItems().length === 0) {
           <div class="empty-state">
                <div class="empty-state-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
                        <polyline points="13 2 13 9 20 9"/>
                        <line x1="9" y1="13" x2="15" y2="13"/>
                    </svg>
                </div>
                <span class="empty-state-title">Nenhum processo encontrado</span>
                <span class="empty-state-subtitle">Não há importações pendentes para a aba selecionada.</span>
            </div>
        } @else {
            <app-import-wizard-pending-list-item
                *ngFor="let item of pendingImportItems()"
                [pendingListItem]="item"
                (onCancel)="refetchPendingImports(item.id)"
            ></app-import-wizard-pending-list-item>
        }
    </div>
</div>